module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BlogHeader"
  }, [_c('break', {
    attrs: {
      "size": "3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "BlogHeader-header"
  }, [_c('title-location', {
    staticClass: "BlogHeader-titleLocation",
    attrs: {
      "title": "Storer Creek Stories",
      "title-route": "/storer-creek",
      "location": _vm.location
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "BlogHeader-yearPicker"
  }, [_c('blog-year-selector', {
    attrs: {
      "years": _vm.years
    }
  })], 1)], 1), _vm._v(" "), _c('rule')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c92a1f64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogHeader.vue
// module id = 795
// module chunks = 1474